module.exports = __webpack_public_path__ + "static/media/icon_overlay.e2706b53.svg";